import React from 'react'
import Grid from '@material-ui/core/Grid';
import * as warningType from '../../flightDetail/warningTypes'

const weightAlert = (props) => {

  let { selectedFlightInfo } = props
  let hasComponentWeightAlert = []
  if (selectedFlightInfo.warnings.length > 0) {
    hasComponentWeightAlert = selectedFlightInfo.warnings.filter(warning => warning.Type == warningType.COMPONENT_WEIGHT)
  }
  function warningMessage() {
    if (hasComponentWeightAlert.length > 0) {
      return hasComponentWeightAlert.map((warning, i) => {
        if (warning.Direction == 1) {
        let warningStr = warning.Message.replace(/'/g, '').split(',')
        return (
          <p key={selectedFlightInfo.LegHashKeyOutbound + i}>
            {
              warningStr.map(item => <div>{item}</div>)
            }
          </p>
        )
      }
      })
    }
    return ''
  }

  return (
    <div >
      <h3>Component Weight Alert</h3>
      {warningMessage()}
    </div>
  )
}

export default weightAlert